import React, { useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import Sign from "../components/Sign";

const SignUpConfirm = () => {
    const [loading, setLoading] = useState(false);
    const [type, setType] = useState("signup_confirm");
    const { token } = useParams();

    const handleSignUpConfirm = async e => {
        setLoading(true);
        try {
            await axios
                .post(
                    "/auditor/business/account/signupConfirm",
                    {
                        email: e.email,
                        token: token
                    }
                )
                .then(async () => {
                    // bad code, plz fix this later
                    setType("signup_confirm_success-login_false")
                    await axios
                        .post(
                            "/auditor/business/account/login",
                            {
                                email: e.email,
                                password: e.password
                            }
                        )
                        .then(res => {
                            setType("signup_confirm_success-login_true")
                        })
                        .catch(error => {
                            setType("signup_confirm_success-login_false")
                            return;
                        })
                })

        } catch (error) {
            setLoading(false);
        }
    }

    return (
        <Sign
            title="Confirm Sign Up"
            type={type}
            formComplete={handleSignUpConfirm}
            errorMessage=""
            loading={loading}
            email=""
        />
    );
}

export default SignUpConfirm;
